import { render } from "./CryptoWalletsQR.vue?vue&type=template&id=645300ca&scoped=true"
import script from "./CryptoWalletsQR.vue?vue&type=script&lang=js"
export * from "./CryptoWalletsQR.vue?vue&type=script&lang=js"

import "./CryptoWalletsQR.vue?vue&type=style&index=0&id=645300ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645300ca"]])

export default __exports__